/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SoftBadge from 'components/SoftBadge';
import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import ellipsis from 'utils/ellipsis';
import fixTableCellWidth from 'utils/fixTableCellWidth';
import Loading from 'components/Loading';
import useModal from 'hooks/useModal';
import TableHeadItems from './TableHeadItems';
import UserMissionDetailModal from './UserMissionDetailModal';

function Row(props) {
    const { row, updateModal } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row?.mission?.name}
                    style={fixTableCellWidth("140px")}>{row?.mission?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.user?.first_name + " " + row?.user?.last_name}
                    style={fixTableCellWidth("150px")}>{row?.user?.first_name + " " + row?.user?.last_name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.done_at}
                    style={{ ...fixTableCellWidth("100px"), cursor: row?.done_at ? "pointer" : "default" }}>{row?.done ? 'بله' : 'خیر'}</TableCell>
                <TableCell className="tablecell" align="left" title={row.approved_at}
                    style={{ ...fixTableCellWidth("100px"), cursor: row.approved_at ? "pointer" : "default" }}>{row?.approved ? 'بله' : 'خیر'}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("80px")}>{row?.mission?.need_to_approve ? 'بله' : 'خیر'}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("150px")}><section style={{ display: "flex", cursor: 'pointer' }}>
                        <SoftBadge variant="contained"
                            onClick={() => updateModal("missionDetail", { state: true, data: row })}
                            badgeContent="اطلاعات بیشتر"
                            size="xs" />
                    </section>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function UserMissionTable({ data, filterInfo, handleFilterChange, onFilterClick, onClearFilterClick }) {
    const navigate = useNavigate()
    const [modals, updateModal, closeModal] = useModal({
        missionDetail: { state: false },
    });
    const closeMissionDetailModal = () => closeModal("missionDetail");

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableHeadItems filterInfo={filterInfo} handleFilterChange={handleFilterChange} onFilterClick={onFilterClick} onClearFilterClick={onClearFilterClick} />
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>نام ماموریت</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>کاربر</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("100px")}>اتمام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("100px")}>تایید</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("100px")}>نیاز به تایید</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {data.map((row) => (
                            <Row key={row.id} row={row} updateModal={updateModal} navigate={navigate} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.missionDetail.state && <UserMissionDetailModal modalInfo={modals.missionDetail} closeModal={closeMissionDetailModal} />}
        </>
    );
}
